import { render, staticRenderFns } from "./liveClassCourseDetails.vue?vue&type=template&id=3517e822&scoped=true"
import script from "./liveClassCourseDetails.vue?vue&type=script&lang=js"
export * from "./liveClassCourseDetails.vue?vue&type=script&lang=js"
import style0 from "./liveClassCourseDetails.vue?vue&type=style&index=0&id=3517e822&prod&lang=less"
import style1 from "./liveClassCourseDetails.vue?vue&type=style&index=1&id=3517e822&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3517e822",
  null
  
)

export default component.exports